import React, { useState, useEffect } from 'react';

const WorkspaceDisplayComponent = ({ workspace, imageWidth, imageHeight, scale, geoToPixel }) => {
  const [pixelWorkspace, setPixelWorkspace] = useState([]);
  useEffect(() => {
    if (typeof geoToPixel === 'function' && workspace && workspace.length > 0) {
      const convertedPath = workspace[0].map(p => geoToPixel(p[0], p[1]));
      setPixelWorkspace(convertedPath);
    } else {
      setPixelWorkspace([]);
    }
  }, [geoToPixel, workspace]);

  if (!workspace || workspace.length === 0 || !geoToPixel) return null;

  const arrowSize = Math.max(50, 100 / scale);
  const arrowPath = `M -${arrowSize/2} -${arrowSize/6} L ${arrowSize/2} 0 L -${arrowSize/2} ${arrowSize/6} Z`;
  const textSize = Math.max(24, 48 / scale); // Adjust text size based on scale
  return (
    <svg width={imageWidth} height={imageHeight} style={{ position: 'absolute', top: 0, left: 0, pointerEvents: 'none' }}>
      <polygon
        points={pixelWorkspace.map(p => `${p[0]},${p[1]}`).join(' ')}
        fillOpacity={0}
        stroke="orange"
        strokeWidth={Math.max(10, 10 / scale)}
        strokeDasharray="20,10ss"
      />
    </svg>
  );
};

export default WorkspaceDisplayComponent;